import _ from 'lodash';
import moment from 'moment';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Page, DealStatusSelect } from '../shared';

import ReactTooltip from 'react-tooltip';

import Insights from './insights';

import Select from 'react-select';

import{
  getIcon
} from '../../util/icons';

import {
  focusAfterTimeout,
  formatThousands,
  getDealCompletion,
  getClassModifierForConfidence,
  getDealItemsAtRisk,
} from '../../util';

import { UpdateDealModal } from '../modals';

import { fetchDealsForTeam } from '../../actions/deals';

import { Redirect, Link } from 'react-router-dom';

const ENTIRE_TEAM_OPTION = {
  value: false,
  memberData: null,
  label: 'Entire Team',
}

const DEALS_PER_PAGE = 5;
const MAX_PAGES_SHOWN = 7;//MUST BE ODD!

class DealsPage extends Component {

  state = {
    pageMessage: null,
    updatingDeal: null,
    redirectingToDeal: false,
    viewingTeam: null,
    viewingTeamMember: false,
    currentPage: 1,
    sortBy: 'confidence',
    isSearching: false,
    searchString: '',
    graphBy: 'value-confidence',
    viewingDealsWithStatus: 'open',
  }

  viewAndFetchDealsForTeam(team){
    this.setState({
      viewingTeam: team
    });

    this.props.fetchDealsForTeam(team);
  }

  componentWillMount(){

    const { defaultTeam } = this.props;

    //fetch deals if unloaded
    if(defaultTeam){
      this.viewAndFetchDealsForTeam(defaultTeam);
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot){
    const { defaultTeam } = this.props;

    if(!prevProps.defaultTeam && defaultTeam){
      this.viewAndFetchDealsForTeam(defaultTeam);
    }
  }

  reloadDeals(){
    this.props.fetchDealsForTeam(this.state.viewingTeam);
  }

  getTeamMemberById(memberId){
    const { viewingTeam } = this.state;

    if(!viewingTeam){
      return {}
    }
    else{
      return _.find(viewingTeam.memberData, { _id: memberId });
    }
  }

  renderDeal(deal){

    const { sortBy } = this.state;

    const { _id, name, status, estimatedValue, estimatedCloseDate, completion, itemsAtRisk, userId } = deal;

    const { confidence } = completion;

    const dealConfidenceClassModifier = getClassModifierForConfidence(confidence);

    const dealSalesPerson = this.getTeamMemberById(userId);

    return(
      <Link key={_id} to={`/deal/${_id}`}>
        <li className="deal">
          <div className="deal-name">{name}</div>
          {sortBy !== 'close' &&
            <React.Fragment>
              <div className="deal-primry-info">${formatThousands(estimatedValue)}</div>
              <div className="deal-secondary-info">{moment(estimatedCloseDate).format('MM/DD/YY')} &middot; {dealSalesPerson.name}</div>
            </React.Fragment>
          }
          {sortBy === 'close' &&
            <React.Fragment>
              <div className="deal-primry-info">{moment(estimatedCloseDate).format('MM/DD/YY')}</div>
              <div className="deal-secondary-info">${formatThousands(estimatedValue)} &middot; {dealSalesPerson.name}</div>
            </React.Fragment>
          }

          {itemsAtRisk && itemsAtRisk.length > 0 &&
            <div data-tip={`Deal has ${itemsAtRisk.length} items at risk`} className="deal-at-risk">{getIcon('warning')}<div className="count">{itemsAtRisk.length}</div></div>
          }
          <div className="deal-confidence">
            <div className={`dial confidence-${dealConfidenceClassModifier}`} style={{width: '60px', height: '60px'}}>
              <div className="dial__progress" data-percent={confidence}></div>
              <div className="dial__content" style={{lineHeight: '50px'}}>{confidence}</div>
              <div className="dial__denominator">/100</div>
            </div>
          </div>
        </li>
      </Link>
    );
  };

  dealsWithViewingStatus(){
    const { viewingDealsWithStatus } = this.state;
    const { deals } = this.props;

    return _.filter(deals || [], { status: viewingDealsWithStatus });
  }

  dealsForViewingTeamOrMember(){
    const { viewingTeam, viewingTeamMember, viewingDealsWithStatus } = this.state;
    const deals = this.dealsWithViewingStatus();

    const mappedDeals = _.map(deals, deal => {

      const itemsAtRisk = getDealItemsAtRisk(deal);

      return {
        ...deal,
        searchString: `${deal.name.toLowerCase()} ${deal.product.toLowerCase()}`,
        completion: getDealCompletion(deal),
        itemsAtRisk,
      }
    });

    if(viewingTeamMember && viewingTeamMember._id){
      return _.filter(mappedDeals, deal => {
        return deal.userId == viewingTeamMember._id;
      }) || [];
    }
    else{
      //viewing entire team, return all deals from props as these contain deals for entire team
      return mappedDeals || [];
    }
  }

  filteredAndSortedDeals(){
    const { sortBy, viewingTeamMember, searchString, viewingDealsWithStatus } = this.state;
    const deals = this.dealsForViewingTeamOrMember();

    if(!deals){
      return [];
    }

    let dealsMatchingSearch = deals;

    const lowerCaseSearchString = searchString.toLowerCase();

    if(searchString && searchString !== ''){
      dealsMatchingSearch = _.filter(deals, deal => {
        return deal.searchString.indexOf(lowerCaseSearchString) > -1;
      });
    }

    //add sort value to deals
    const mappedDeals = _.map(dealsMatchingSearch, deal => {

      const sortValue = (sortBy === 'confidence' ? (-1 * deal.completion.confidence) :
                        (sortBy === 'close' ? deal.estimatedCloseDate :
                        (sortBy === 'atrisk' ? (-1000000000 * deal.itemsAtRisk.length - deal.estimatedValue) : (-1 * deal.estimatedValue))));

      return {
        ...deal,
        sortValue,
      }
    });

    let filteredDeals = mappedDeals;

    if(sortBy === 'atrisk'){
      filteredDeals = _.filter(filteredDeals, deal => {
        return deal.itemsAtRisk.length > 0
      });
    }

    const sortedAndFilteredDeals = _.sortBy(filteredDeals, 'sortValue');

    return sortedAndFilteredDeals;
  }

  getDealsPage(){
    const { currentPage } = this.state;
    const filteredAndSortedDeals = this.filteredAndSortedDeals();

    const totalPageCount = Math.ceil(filteredAndSortedDeals.length / DEALS_PER_PAGE);

    const startAt = (currentPage - 1) * DEALS_PER_PAGE;
    const endAt = (currentPage) * DEALS_PER_PAGE;

    const dealsOnCurrentPage = _.slice(filteredAndSortedDeals, startAt, endAt);

    const prevPageEnabled = currentPage > 1;
    const nextPageEnabled = currentPage < totalPageCount;

    let pages = Array.from(new Array(totalPageCount),(val,index)=>index + 1);

    let firstPageShowing = currentPage - 4 <= 1;
    let lastPageShowing = currentPage + 4 >= totalPageCount;

    //need to trim to fit
    if(pages.length > MAX_PAGES_SHOWN){

      const MAX_PAGES_ABOVE_OR_BELOW = (MAX_PAGES_SHOWN - 1) / 2;

      console.log('MAX_PAGES_ABOVE_OR_BELOW: ', MAX_PAGES_ABOVE_OR_BELOW);

      if(currentPage > (totalPageCount / 2)){
        //will start with taking higher pages (since we might run out of pages above current page)
        const pagesAboveCurrent = Math.min(totalPageCount - currentPage, MAX_PAGES_ABOVE_OR_BELOW);
        console.log('pagesAboveCurrent: ', pagesAboveCurrent);
        pages = _.slice(pages, currentPage - (MAX_PAGES_SHOWN - 1 - pagesAboveCurrent) - 1, currentPage + pagesAboveCurrent);
      }
      else{
        //reverse of above
        const pagesBelowCurrent = Math.min(currentPage - 1, MAX_PAGES_ABOVE_OR_BELOW);
        console.log('pagesBelowCurrent: ', pagesBelowCurrent);
        pages = _.slice(pages, currentPage - pagesBelowCurrent - 1, currentPage + (MAX_PAGES_SHOWN - 1 - pagesBelowCurrent));
      }
    }

    return {
      allDeals: filteredAndSortedDeals,
      currentPage,
      dealsOnCurrentPage,
      totalPageCount,
      prevPageEnabled,
      nextPageEnabled,
      pages,
    };
  }

  goToPage(page){
    this.setState({
      currentPage: page
    });
  }

  goToPrevPage(){
    this.setState({
      currentPage: this.state.currentPage - 1
    });
  }
  goToNextPage(){
    this.setState({
      currentPage: this.state.currentPage + 1
    });
  }

  updateSortBy(sortBy){
    this.setState({
      currentPage: 1,
      sortBy,
    });
  }

  startSearchingDeals(){
    this.setState({
      isSearching: true,
      searchString: ''
    },() => {
      focusAfterTimeout(this, 'dealSearchInput');
    });
  }

  handleDealSearchBlur(){
    if(this.state.searchString === ''){
      this.setState({
        isSearching: false
      });
    }
  }

  updateSearchString(searchString){
    this.setState({
      searchString,
      currentPage: 1,
    });
  }

  renderDealListSearch(){
    const { isSearching, searchString } = this.state;

    return(
      <div className="deal-search">
        {isSearching &&
          <input
            value={searchString}
            ref={input => { this.dealSearchInput = input; }}
            type="text"
            placeholder="Name or product"
            onChange={e => { this.updateSearchString(e.target.value); }}
            onBlur={this.handleDealSearchBlur.bind(this)}
          />
        }
        {!isSearching &&
          <div
            className="start-search"
            onClick={this.startSearchingDeals.bind(this)}
            >{getIcon('search')}<span>Search</span></div>
        }
      </div>
    );
  }

  renderDealsSort(){
    const { sortBy, viewingDealsWithStatus } = this.state;

    const viewingDealsWithOpenStatus = viewingDealsWithStatus === 'open';

    return (
      <ul className="section-toggles deals-sort-by">
        {viewingDealsWithOpenStatus &&
          <li onClick={() => { this.updateSortBy('confidence'); }} className={sortBy === 'confidence' ? 'active' : ''}>Deal Confidence</li>
        }
        <li onClick={() => { this.updateSortBy('close'); }} className={sortBy === 'close' ? 'active' : ''}>Close Date</li>
        <li onClick={() => { this.updateSortBy('value'); }} className={sortBy === 'value' ? 'active' : ''}>Deal Value</li>
        {viewingDealsWithOpenStatus &&
          <React.Fragment>
            <li className="divider">|</li>
            <li onClick={() => { this.updateSortBy('atrisk'); }} className={sortBy === 'atrisk' ? 'active' : ''}>At Risk</li>
          </React.Fragment>
        }
      </ul>
    )
  }

  renderDeals(){

    const {
      allDeals,
      dealsOnCurrentPage,
      currentPage,
      totalPageCount,
      prevPageEnabled,
      nextPageEnabled,
      pages
    } = this.getDealsPage();

    const { sortBy, viewingTeamMember, viewingTeam, searchString, viewingDealsWithStatus } = this.state;

    return(
      <div className="page-section fourty">
        {/*<h2>Open Deals{viewingTeamMember && ` for ${viewingTeamMember.name}`}</h2>*/}
        <h2>Deals</h2>
        {this.renderDealListSearch()}
        {this.renderDealsSort()}
        {allDeals.length === 0 &&
          <p>{viewingTeamMember ? viewingTeamMember.firstName : (viewingTeam || {}).name} has no {sortBy === 'atrisk' ? 'at risk' : viewingDealsWithStatus} {searchString !== '' ? `deals matching \"${searchString}\"` : `deals`}.</p>
        }
        <ul className="deals-list">
          {_.map(dealsOnCurrentPage, this.renderDeal.bind(this))}
        </ul>
        {totalPageCount > 1 &&
          <div className="deals-pagination">
            <ul className="pages">
              {_.map(pages, page => {
                return <li
                  key={page}
                  className={page === currentPage ? 'active' : ''}
                  onClick={() => { this.goToPage(page); } }
                  >{page}</li>
              })}
            </ul>
            <button
              className="prev-button button grey-outline button-tiny"
              disabled={!prevPageEnabled}
              onClick={this.goToPrevPage.bind(this)}
            >&lt;</button>
            <button
              className="next-button button grey-outline button-tiny"
              disabled={!nextPageEnabled}
              onClick={this.goToNextPage.bind(this)}
            >&gt;</button>
          </div>
        }
        <ReactTooltip effect="solid" place="top"/>
      </div>
    )
  }

  renderDealInsights(){

    const { graphBy, viewingTeamMember } = this.state;

    const deals = this.filteredAndSortedDeals();

    return (
      <div className="page-section insights-section sixty">
        {/*<h2>Deal Insights{viewingTeamMember && ` for ${viewingTeamMember.name}`}</h2>*/}
        <h2>Deal Insights</h2>
        <ul className="section-toggles deals-graph-by">
          <li onClick={() => { console.log('Not implemented yet.'); }} className={graphBy === 'value-confidence' ? 'active' : ''}>Value * Confidence</li>
        </ul>
        <Insights
          onDealClick={dealId => { this.setState({ redirectingToDeal: dealId }); }}
          deals={this.dealsForViewingTeamOrMember()} />
      </div>
    )
  }

  beginUpdatingDeal(deal){
    this.setState({
      updatingDeal: { ...deal }
    });
  }

  afterDealUpdate(deal){
    this.reloadDeals();

    this.setState({
      updatingDeal: null
    });
  }

  getTeamMemberOptions(){
    const { viewingTeam } = this.state;

    if(!viewingTeam){
      return [];
    }

    const teamMembersOptions = _.map(viewingTeam.memberData, member => {

      const { _id, name } = member;

      return {
        value: _id,
        memberData: member,
        label: name
      }
    });

    return [
      ENTIRE_TEAM_OPTION,
      ...teamMembersOptions
    ];
  }

  getTeamOptions(){
    const { myTeams } = this.props;

    if(!myTeams){
      return [];
    }

    const teamOptions = _.map(myTeams, team => {
      return {
        value: team._id,
        label: team.name
      }
    });

    return teamOptions;
  }
  getViewingTeamSelectValue(){
    const { viewingTeam } = this.state;

    if(!viewingTeam){
      return null;
    }

    const matchingTeam = _.find(this.getTeamOptions(), team => {
      return team.value === viewingTeam._id;
    });

    return matchingTeam;
  }

  getViewingTeamMemberSelectValue(){
    const { viewingTeamMember } = this.state;

    if(!viewingTeamMember){
      return ENTIRE_TEAM_OPTION;
    }

    const matchingTeamMember = _.find(this.getTeamMemberOptions(), member => {
      return member.value === viewingTeamMember._id;
    });

    return matchingTeamMember || ENTIRE_TEAM_OPTION;
  }

  viewTeam(teamId){
    const { myTeams } = this.props;

    this.setState({
      viewingTeamMember: false,
      viewingTeam: _.find(myTeams, {_id: teamId})
    }, () => {
      this.reloadDeals();
    });
  }

  viewTeamMember(teamMember){
    const { viewingTeam } = this.props;

    this.setState({
      viewingTeamMember: teamMember,
    });
  }

  updateViewingDealsStatus(viewingDealsWithStatus){

    if(viewingDealsWithStatus !== 'open'){
      this.updateSortBy('close');
    }
    else{
      this.updateSortBy('confidence');
    }

    this.setState({
      viewingDealsWithStatus
    });
  }

  renderViewingDealsWithStatusSelect(){
    return (
      <DealStatusSelect
        value={this.state.viewingDealsWithStatus}
        onUpdate={newStatus => { this.updateViewingDealsStatus(newStatus); }}
      />
    )
  }

  renderTeamMemberSelect(){
    const teamMembersOptions = this.getTeamMemberOptions();

    if(!teamMembersOptions || teamMembersOptions.length === 0){
      return null;
    }

    const selectedOption = this.getViewingTeamMemberSelectValue();

    return (
      <Select
        classNamePrefix={'react-select'}
        className={`react-select-container member-select ${!selectedOption.value && 'none-selected'}`}
        value={selectedOption}
        options={teamMembersOptions}
        onChange={(option) => { this.viewTeamMember(option.memberData) }}
        isSearchable={false}
      />
    )
  }

  renderTeamSelect(){

    const teamOptions = this.getTeamOptions();

    if(!teamOptions || teamOptions.length === 0){
      return null;
    }

    return (
      <Select
        classNamePrefix={'react-select'}
        className='react-select-container team-select'
        value={this.getViewingTeamSelectValue()}
        options={teamOptions}
        onChange={(option) => { this.viewTeam(option.value) }}
        isSearchable={false}
      />
  );
  }

  renderDealsPageTitle(){

    const deals = this.props.deals || [];

    const { viewingDealsWithStatus, viewingTeam, viewingTeamMember } = this.state;

    const dealTotalToDisplay = _.reduce(deals, (memo, deal) => {
      if(viewingTeamMember){
        return memo + (deal.status === viewingDealsWithStatus && deal.userId === viewingTeamMember._id ? deal.estimatedValue : 0);
      }
      else{
        return memo + (deal.status === viewingDealsWithStatus ? deal.estimatedValue : 0);
      }
    }, 0);

    const dealTotalLabel = viewingDealsWithStatus === 'open' ? 'in pipeline' : (viewingDealsWithStatus === 'won' ? 'in won deals' : 'in lost deals');

    return(
      <div className="page-title">
        <h1>{(viewingTeamMember || viewingTeam || {}).name}{`'`}s {viewingDealsWithStatus.substring(0,1).toUpperCase() + viewingDealsWithStatus.substring(1)} Deals</h1>
        <h3>${formatThousands(dealTotalToDisplay)} {dealTotalLabel}</h3>
      </div>
    )
  }

  // getDealsForCurrentView(){
  //   const deals = this.props.deals || [];
  //
  //   const { viewingDealsWithStatus, viewingTeam, viewingTeamMember } = this.state;
  //
  //   return _.filter(deals, deal => {
  //
  //   });
  // }

  render(){

    if(this.state.redirectingToDeal){
      const redirectToUrl = `/deal/${this.state.redirectingToDeal}`;
      return <Redirect to={redirectToUrl} />
    }

    const deals = this.props.deals || [];

    const { viewingTeam } = this.state;

    const loading = !this.props.user || this.props.loadingTeams || this.props.loadingDeals || !viewingTeam;

    return (
      <Page
        pageClass="deals"
        loading={loading}
        pageMessage={this.state.pageMessage}
        clearMessage={() => { this.setState({ pageMessage: null }) }}
        hideSidebar={true}
      >
        {this.renderDealsPageTitle()}
        <div className="page-actions">
          <div className="select-group">
            {this.renderViewingDealsWithStatusSelect()}
            {this.renderTeamSelect()}
            {this.renderTeamMemberSelect()}
          </div>
        </div>

        <div className="page-content">
          {this.renderDeals()}
          {this.renderDealInsights()}
        </div>

        <UpdateDealModal
          hide={() => { this.setState({ updatingDeal: null }) }}
          editingDeal={this.state.updatingDeal}
          visible={!!this.state.updatingDeal}
          onUpdate={this.afterDealUpdate.bind(this)}
        />
      </Page>
    )
  }
}

function mapStateToProps(state){
  return {
    user: state.user,
    myTeams: state.myTeams.data,
    loadingTeams: state.myTeams.loading,
    loadingDeals: state.deals.loading,
    deals: state.deals.data,
    defaultTeam: state.myTeams.data && (state.myTeams.data[0] || false) || false
  }
}

export default connect(mapStateToProps, { fetchDealsForTeam })(DealsPage);



// WEBPACK FOOTER //
// ./src/components/deals/index.js